import { gql, useQuery } from '@apollo/client';
import { useEffect } from 'react';
import { useCurrentMemberContext } from 'src/contexts';

export const GET_ALL_EMPLOYEES_WORKING_HOURS_BY_GANTT_ID = gql`
  query getAllEmployeesWorkingHoursByGanttId($ganttId: ObjectId!) {
    getAllEmployeesWorkingHoursByGanttId(ganttId: $ganttId) {
      _id
      employeeId
      startFrom
      startFromString
      breakTime
      monday {
        from
        to
      }
      tuesday {
        from
        to
      }
      wednesday {
        from
        to
      }
      thursday {
        from
        to
      }
      friday {
        from
        to
      }
      saturday {
        from
        to
      }
      sunday {
        from
        to
      }
    }
  }
`;

export const EMPLOYEES_WORKING_HOURS_CHANGED_SUBSCRIPTION = gql`
  subscription employeesWorkingHoursChanged($ganttId: ObjectId!) {
    employeesWorkingHoursChanged(ganttId: $ganttId) {
      trigger
      employeeWorkingHours {
        _id
        employeeId
        startFrom
        startFromString
        monday {
          from
          to
        }
        tuesday {
          from
          to
        }
        wednesday {
          from
          to
        }
        thursday {
          from
          to
        }
        friday {
          from
          to
        }
        saturday {
          from
          to
        }
        sunday {
          from
          to
        }
      }
    }
  }
`;

export const useGetAllWorkingHoursByCurrentGantt = () => {
  const { ganttId } = useCurrentMemberContext();
  const { data, loading, subscribeToMore } = useQuery(GET_ALL_EMPLOYEES_WORKING_HOURS_BY_GANTT_ID, {
    variables: { ganttId },
    skip: !ganttId,
    fetchPolicy: 'network-only',
  });

  const employeesWorkingHours = data?.getAllEmployeesWorkingHoursByGanttId || [];

  useEffect(() => {
    if (ganttId)
      subscribeToMore({
        document: EMPLOYEES_WORKING_HOURS_CHANGED_SUBSCRIPTION,
        variables: { ganttId },
        updateQuery: (prev, { subscriptionData }) => {
          if (!subscriptionData.data) return prev;

          const { trigger, employeeWorkingHours } =
            subscriptionData.data?.employeesWorkingHoursChanged || {};
          const employeesWorkingHours = prev?.getAllEmployeesWorkingHoursByGanttId || [];
          const newEmployeesWorkingHours = [...employeesWorkingHours];
          const findIndex = employeesWorkingHours.findIndex(
            (value: any) => value._id === employeeWorkingHours._id
          );

          if (trigger === 'employeesWorkingHoursCreated' && findIndex < 0) {
            newEmployeesWorkingHours.push(employeeWorkingHours);
          }

          if (findIndex > -1 && trigger === 'employeesWorkingHoursRemoved') {
            newEmployeesWorkingHours.splice(findIndex, 1);
          }

          return { getAllEmployeesWorkingHoursByGanttId: newEmployeesWorkingHours };
        },
      });
  }, [subscribeToMore, ganttId]);

  return { employeesWorkingHours, loading };
};
